import { SessionGraph } from './SessionGraph';
import { StatsOverlay } from './StatsOverlay';
import { ConnectionIndicator } from './ConnectionIndicator';

export function Dashboard() {
  return (
    <div className="dashboard">
      <div className="canvas-container">
        <SessionGraph />
        <StatsOverlay />
        <ConnectionIndicator />
      </div>
    </div>
  );
}
